import { render } from "./SearchBlock.vue?vue&type=template&id=5e5cb7bf&scoped=true&ts=true"
import script from "./SearchBlock.vue?vue&type=script&lang=ts"
export * from "./SearchBlock.vue?vue&type=script&lang=ts"

import "./SearchBlock.vue?vue&type=style&index=0&id=5e5cb7bf&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5cb7bf"]])

export default __exports__